<template>
    <elitigation-sessions></elitigation-sessions>
  </template>
  
  <script>
  import ElitigationSessions from '../components/elitigation-sessions/index.vue';
  
  export default { components: { ElitigationSessions } };
  
  </script>
  